import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * Ensures all API requests go to the absolute environment.apiUrl.
 * If a request URL is relative and starts with '/api' or 'api',
 * it will be rewritten to `${environment.apiUrl}/...`.
 * Absolute URLs (http/https) are left untouched.
 */
export const apiBaseUrlInterceptor: HttpInterceptorFn = (request, next) => {
  const url = request.url || '';

  // Leave absolute URLs untouched
  if (/^https?:\/\//i.test(url)) {
    return next(request);
  }

  // No longer checking for /api prefix as the base URL is the domain root
  let newUrl = `${environment.apiUrl}/${url.replace(/^\//, '')}`;

  // Normalize duplicate slashes except after protocol
  newUrl = newUrl.replace(/([^:]\/)\/+/, '$1');

  const rewritten = request.clone({ url: newUrl });
  return next(rewritten);
};
